module.exports = __webpack_public_path__ + "68616cd10604b31ff11b97aa14895c33.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/glasses-old-man-s.png
// module id = 1827
// module chunks = 0